(function($){
    var $fn = $(".comp_events");

    if (!$fn.length) {
        return;
    }

    var lang = document.documentElement.lang,
        locales = {
            cs: {
                days: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
                daysShort: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
                daysMin: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
                months: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
                monthsShort: ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čvn', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],
                today: 'Dnes',
                clear: 'Vymazat',
                dateFormat: 'dd.MM.yyyy',
                timeFormat: 'HH:mm',
                firstDay: 1
            },
            de: {
                days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                daysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                today: 'Heute',
                clear: 'Löschen',
                dateFormat: 'dd.MM.yyyy',
                timeFormat: 'HH:mm',
                firstDay: 1
            },
            en: {
                days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                today: 'Today',
                clear: 'Clear',
                dateFormat: 'MM/dd/yyyy',
                timeFormat: 'hh:mm aa',
                firstDay: 0
            }
        };

    function initEventsDatepicker() {
        $fn.find('[data-target="datepicker"]').each(function(){
            var element = this,
                selectedDate = element.getAttribute("data-selected-date"),
                eventDates = [];

            try {
                eventDates = JSON.parse(element.getAttribute("data-event-dates")) || [];
            } catch (e) {
                eventDates = [];
            }

            new AirDatepicker(element, {
                inline: true,
                startDate: selectedDate ? new Date(selectedDate) : new Date(),
                locale: locales[lang] || locales[lang.substr(0, 2)] || locales.en,
                dateFormat: 'yyyy-MM-dd',
                onRenderCell: function(params) {
                    if (params.cellType !== 'day') {
                        return {};
                    }

                    var dateString = params.date.getFullYear() + '-' +
                        String(params.date.getMonth() + 1).padStart(2, '0') + '-' +
                        String(params.date.getDate()).padStart(2, '0');

                    return eventDates.indexOf(dateString) !== -1 ? {classes: '-has-event-'} : {};
                }
            });
        });
    }

    if (typeof AirDatepicker === "undefined") {
        $.getScript("https://cdn.jsdelivr.net/npm/air-datepicker@3.6.0/air-datepicker.min.js").done(initEventsDatepicker);
    } else {
        initEventsDatepicker();
    }
})(jQuery);
